// ** React Imports
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress'
import {
    Divider,
    IconButton,
    Tooltip,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import apiUrl from '../../../configs/constant';
import { useToast } from '../../../components/ToastProvider';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast } = useToast();

    // ** State
    const [listData, setListData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        getData()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        setListData([])
        showToast("Loading", "loading");
        const url = apiUrl.apiUrl + '/mm/batch/list'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleDelete = (row: any) => {
        showToast("Loading", "loading");
        const url = apiUrl.apiUrl + '/mm/batch/delete/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Hapus Dokumen",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
                <Tooltip title="Cetak Label">
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation(); // ✅ cegah rowClick
                            window.open(
                                `${apiUrl.baseUrl}/mm/batch/cetak-label-batch/${row.id}`,
                                '_blank'
                            );
                        }}
                    >
                        <Icon icon={"mdi:qrcode"} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    const hiddenColumns =
        [
            'mmbarang_id',
            'created_at',
            'created_by',
            'updated_at',
            'updated_by'
        ]

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='MASTER BATCH' />
                        </Box>
                    </Box>
                    <Divider />
                    {loading ? (
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                            <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                        </Grid>
                    ) : (
                        <MsiDatagrid array={listData} actions={actionData}
                         hiddenColumns={hiddenColumns} 
                         />
                    )}
                </div>
            </Grid>
        </Grid>
    )
}
